<template>
  <div class="center-footer">
    <div class="footer-content">
      <span>（建议您使用IE9及以上版本浏览器访问本网站）</span>
      <span>技术支持：长沙普益云软件科技有限公司</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.center-footer {
  width: 100%;
  background-color: #9b0204;
  margin-top: 60px;
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 22px 0;

    > span {
      font-size: 14px;
      color: #cb5c5e;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Hospital/public/foot.vue